import PropTypes from 'prop-types';
import SetPassword from 'Components/SetPassword';

const ForgotPassword = ({ strings }) => (
  <SetPassword isReset strings={strings} />
);

ForgotPassword.propTypes = {
  strings: PropTypes.object.isRequired,
};

export default ForgotPassword;
